import { Button, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import Image from 'src/components/image/image';
import Iconify from 'src/components/iconify';
import axios from 'src/utils/axios';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  imageUrl: string | null;
  disableRightClick?: boolean;
  fileName?: string;
};

export function ImagePreviewDialog({
  open,
  onClose,
  imageUrl,
  disableRightClick = false,
  fileName,
}: Props) {
  const handleContextMenu = (e: React.MouseEvent) => {
    if (disableRightClick) {
      e.preventDefault();
      return false;
    }
    return undefined;
  };

  const handleDownload = async () => {
    if (!imageUrl) return;

    try {
      let downloadUrl = imageUrl;
      let shouldRevoke = false;
      let downloadFileName = fileName;

      // Extract filename from URL if not provided
      if (!downloadFileName && !imageUrl.startsWith('blob:')) {
        try {
          const url = new URL(imageUrl);
          const path = decodeURIComponent(url.pathname);
          const name = path.split('/').pop();
          if (name) downloadFileName = name;
        } catch (e) {
          console.error('Error parsing filename:', e);
        }
      }

      if (!imageUrl.startsWith('blob:')) {
        try {
          const res = await axios.get('/download/public-file', {
            params: { url: imageUrl },
            responseType: 'blob',
          });
          const blob = res.data;
          downloadUrl = URL.createObjectURL(blob);
          shouldRevoke = true;
        } catch (error) {
          console.error('Proxy download failed, falling back to direct fetch:', error);
          const response = await fetch(imageUrl);
          const blob = await response.blob();
          downloadUrl = URL.createObjectURL(blob);
          shouldRevoke = true;
        }
      }

      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = downloadFileName || 'image';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      if (shouldRevoke) {
        URL.revokeObjectURL(downloadUrl);
      }
    } catch (error) {
      console.error('Download error:', error);
    }
  };

  return (
    <>
      {imageUrl && (
        <Dialog open={open} onClose={onClose}>
          <DialogTitle>รูปภาพ</DialogTitle>
          <DialogContent>
            <Image
              src={imageUrl}
              alt=""
              onContextMenu={handleContextMenu}
              draggable={disableRightClick ? false : undefined}
              sx={{
                width: '100%',
                height: '100%',
                userSelect: disableRightClick ? 'none' : 'auto',
                border: 'solid 1px',
                borderColor: 'divider',
                borderRadius: 1,
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownload}
              startIcon={<Iconify icon="mdi:download" />}
            >
              ดาวน์โหลด
            </Button>
            <Button variant="outlined" onClick={onClose}>
              ปิด
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
